export const isVideo = path =>
  ['.mp4', 'webm'].includes(path.substr(path.length - 4));
